// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import {
  CredentialOffer,
  CredentialOffer_AcceptFree_Result,
} from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Model/Offer';
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useAcceptFreeCredentialOffer: () => UseMutationResult<
  CredentialOffer_AcceptFree_Result,
  string,
  {
    userServiceCid: ContractId<UserService>;
    credentialOfferCid: ContractId<CredentialOffer>;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { party } = useParties();

  return useMutation({
    mutationKey: ['acceptFreeCredential', ledgerApi, party],
    mutationFn: async ({ userServiceCid, credentialOfferCid }) => {
      return ledgerApi.acceptFreeCredential(userServiceCid, credentialOfferCid, [party]);
    },
  });
};

export default useAcceptFreeCredentialOffer;
